import { GlobalToken, theme } from "antd";
import { CSSProperties, ReactNode } from "react";
import { SparkleIcon } from "src/components/SparkleIcon";
import { useScrollTop } from "src/hooks/useScrollTop";

export function InsightsPanel(props: { cards: ReactNode[] }) {
  const { token } = theme.useToken();
  const [scrollRef, scrollTop] = useScrollTop();
  if (props.cards.length === 0) return null;
  return (
    <div style={panelContainerStyle(token)}>
      <div style={fixedHeaderStyle(token)}>
        <SparkleIcon /> Analysis
      </div>
      <div style={shadowContainerStyle(token)}>
        {scrollTop > 4 && <div style={shadowInsertStyle(token)} />}
        <div style={scrollParentStyle(token)} ref={scrollRef}>
          <div style={cardsContent(token)}>{props.cards}</div>
        </div>
      </div>
    </div>
  );
}
const panelContainerStyle: DynamicCss = (token) => ({
  height: "100%",
  overflow: "auto",
  minWidth: 0,
  maxWidth: "100%",
  width: 350,
  flex: 1,
  display: "flex",
  flexDirection: "column",
  position: "relative",
  color: token.colorText,
});

const fixedHeaderStyle: DynamicCss = (_) => ({
  paddingTop: 38,
  paddingLeft: 28,
  fontSize: 18,
  lineHeight: "18px",
  fontWeight: 500,
  height: 88,
});

const shadowContainerStyle: DynamicCss = (_) => ({
  flex: 1,
  overflow: "hidden",
});

const shadowInsertStyle: DynamicCss = (token) => ({
  boxShadow: `inset 0 1px 1.5px ${token.colorBgBase}`,
  backgroundColor: "transparent",
  width: "100%",
  left: 0,
  height: 1,
  overflow: "visible",
});

const scrollParentStyle: DynamicCss = (_) => ({
  height: "100%",
  overflow: "auto",
  overflowX: "hidden",
  padding: 16,
  paddingBottom: 40,
});

const cardsContent: DynamicCss = (_) => ({
  display: "flex",
  flexDirection: "column",
  gap: 16,
  width: "100%",
});

type DynamicCss = (token: GlobalToken) => CSSProperties;
